'use strict';

import React, {useCallback, useMemo} from 'react';
import {h, Fragment} from 'preact';
import {trans} from '../../../../l10n';
import mix from '../../../../helpers/mix';
import Mix from '../../../../helpers/mix';
import {discount} from '../../Partnership';

export default function ItemMobile(props) {
    const product = useMemo(() => props.product, [props.product]);

    const gaEvent = useCallback(() => {
        typeof ga !== 'undefined' && ga?.getAll()?.[0]?.send('event', 'КаталогМоделей', 'ЗаказатьВ1Клик');
    }, []);

    const discounted = useMemo(() => {
        return global.config.isPartnerMode ? discount(product.price.final_price) : null;
    }, [product.price]);

    return (
        <div className='item col-md-6 col-lg-6 col-sm-6 col-xs-6 js-good' data-id={product.id}>
            <div className='card item_shadow border-r'>
                <div className='item_h'>
                    <a className='main_link' href={product.url}>
                        <div className='img_block'>
                            <img src={product.imageUrl} width='192' height='225' alt='' />

                            {product.photos3D > 0 && (
                                // Этот товар можно покрутить в 3D
                                <div className='threeD' title={trans('catalog.3dphoto_hint_short')}></div>
                            )}

                            {product.price_down > 0 && (
                                // Есть уцененный товар
                                <div
                                    className='ucenka'
                                    title={trans('catalog.have_ucenka_products')}
                                    style={{
                                        background: `url(${Mix.img(
                                            '/images/' + product.priceDownValue + '-1.png'
                                        )}) no-repeat`,
                                    }}></div>
                            )}

                            {product.sticker !== null && <div dangerouslySetInnerHTML={{__html: product.sticker}}></div>}
                        </div>

                        <div className='name'>
                            <div className='product-name'>{product.name}</div>
                        </div>
                    </a>
                    <div>
                        {/* Артикул: */}
                        {trans('catalog.field_articul')} {product.articul}
                    </div>

                    {global.config.isMaster && (
                        <div style={{fontSize: '12px'}}>
                            {trans('catalog.price_roznicnaya')} <span>{product.priceRetail}</span>{' '}
                            {product.price.show_symb}
                        </div>
                    )}

                    <div className='price'>
                        {product.availableValue && (
                            <>
                                <div className='number'>
                                    <span>{product.price.final_price}</span> {product.price.show_symb}
                                </div>

                                {discounted !== null && (
                                    <div className='number catalog_price_old'>
                                        <span>{discounted}</span> {product.price.show_symb}
                                    </div>
                                )}
                            </>
                        )}

                        <div className='stock' dangerouslySetInnerHTML={{__html: product.available}}></div>
                    </div>

                    {product.availableValue && (
                        <>
                            <a
                                rel="nofollow"
                                href='javascript:void(0)'
                                className='butBlue js-into-basket'
                                data-good_id={product.id}
                                data-nameov={product.detailName}>
                                <img data-original={mix.img('/images/mob/cart.png')} width='30' className='lazy' />
                            </a>

                            <div className={'like-btn ' + (product.favorite ? 'active' : '')}>
                                <a
                                    rel="nofollow"
                                    href='javascript:void(0)'
                                    className='js-favorite-toggle'
                                    data-good-id={product.id}
                                    title={trans('catalog.add_to_favorite')}></a>
                            </div>

                            {global.config.country === 'UA' && (
                                // Купить в 1 клик
                                <a
                                    href='#'
                                    className='one_click_btn js-one-click-btn'
                                    data-nameov={product.detailName}
                                    data-namea={product.detailKogo}
                                    data-name={product.unlocalizedName}
                                    onClick={gaEvent}>
                                    {trans('catalog.one_click_buy')}
                                </a>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
